module.exports = __webpack_public_path__ + "img/Freddie Hairston, 1968.4f005c56.jpg";